<template>
	<ui-modal @toggle="$emit('toggle')">
		<Head title="Création d'un status" />
		<form method="post" @submit.prevent="handleSubmit" class="flex flex-col gap-2">
			<ui-title textSize="big" textPosition="left" class="text-slate-700">
				<template v-slot:text>
					<p>Ajouter un status</p>
				</template>
			</ui-title>

			<form-select :items="types" placeholder="Type *" @valueChange="form.type = $event" :value="form.type" class=""> </form-select>
			<form-input placeholder="Nom *" v-model="form.name"> </form-input>
			<form-input placeholder="Slug *" v-model="form.slug"> </form-input>
			<p v-if="form.type == 'action'" class="flex items-center justify-between">
				Décompter comme une visite : <ui-toggle v-model="form.show" :icons="['fa-check', 'fa-xmark']" />
			</p>

			<form-validation-errors class=""></form-validation-errors>
			<ui-button class="mt-3 font-bold border-2" position="center" @click.prevent="handleSubmit()" :loading="loading">
				<template v-slot:text>Valider</template>
			</ui-button>
		</form>
	</ui-modal>
</template>

<script setup>
	import { ref, onMounted, watch } from 'vue';
	import { Head, useForm, usePage, router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';

	const page = usePage();

	const emit = defineEmits(['toggle']);

	const loading = ref(false);
	const types = ref([]);

	const form = useForm({
		name: null,
		type: null,
		slug: null,
		show: false,
	});

	watch(
		() => form.type,
		(newType) => {
			if (newType === 'action') {
				form.show = false;
			}
		},
	);

	const handleSubmit = () => {
		loading.value = true;
		form.post(route('admin.statuses.store'), {
			preserveScroll: true,
			onSuccess: () => {
				router.visit(route('admin.statuses'));
				toast.success('Status créé avec succès !');
			},
			onFinish: () => {
				loading.value = false;
			},
		});
	};

	onMounted(() => {
		page.props.str.statuses.forEach((status) => {
			if (!types.value.some((e) => e.value == status.type)) {
				types.value.push({
					name: page.props.str.types[status.type],
					value: status.type,
				});
			}
		});
	});
</script>
